import { useClientRest } from "@shared/hooks";
import { toSnake, transformQueryParamsWithoutLocale } from "@shared/utils";
import { Kh_Provinces } from "@sisnaker-react-core/karirhub-model-type";
import { useQuery } from "@tanstack/react-query";

export function useProvinces({
  keyword,
  page = 1,
  limit = 10,
  enabled = true,
}: {
  keyword: string;
  page?: number;
  limit?: number;
  enabled?: boolean;
}) {
  const { request } = useClientRest();

  const query = useQuery<{ data: Kh_Provinces[] }>({
    queryKey: ["common-provinces-", keyword, limit, page],
    queryFn: () =>
      request({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/provinces", toSnake({
          keyword,
          limit,
          page,
        })),
        method: "GET",
        options: {
          cache: "no-store",
        },
      }),
    enabled: enabled,
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    provinces: query.data?.data || [],
    query,
    refetch,
  };
}
